/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Steuerklassepartner1Inputs */



/**

* @param {_Field_Steuerklassepartner1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_steuerklassepartner1 = /** @type {((inputs?: _Field_Steuerklassepartner1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Steuerklassepartner1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Steuerklasse des Ehegatten/Lebenspartners")
});
export { _field_steuerklassepartner1 as "_field_steuerklassePartner" }